// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3-9j7","actionsCol":"EnrolledClinics_actionsCol__fiBLt"};